var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cboecomp"},[_c('div',{staticClass:"image",domProps:{"innerHTML":_vm._s(_vm.html)}}),(_vm.data.caption)?_c('p',{staticClass:"mt-3 has-text-centered is-size-8"},[_vm._v(" "+_vm._s(_vm.data.caption)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }